import {
  get,
  post,
  put,
  del
} from '../configApi'

export async function loadSkill() {
  return await get(`/skill/list`)
}
export async function loadSkillList(params) {
  return await get(`/skill/list/admin`,params)
}
export async function insertSkill(body) {
  return await post(`/skill/add`, body)
}
export async function updateSkill(body) {
  return await put(`/skill/update`, body)
}
export async function updateActive(body) {
  return await put(`/skill/active`, body)
}
export async function deleteSkill(body) {
  return await del(`/skill/delete`, body)
}
export async function getSkillListBin(body) {
  return await get(`/skill/list/adminbin`, body)
}